

<div class="margin">
  <panel heading="{{systemTitle | translate | async}}">
    <div class="photo-container">
              <div  class="photo-container">
               <ng-container *ngFor="let photo of system?.SystemImages">
                <div>
                  <img class="inspection-observation-photo" [src]="photo.ImageUrl"
                    (click)="viewComponentPhoto(photo,c,  5,photo.SystemId,true)" />
                </div>
              </ng-container>
                
                <upload-photo (SystemPhotoUpload)="AddSystemImagesArray($event)"  [inspectionId]="inspectionId" [inspectionDetailId]="system?.SystemId" [comingFrom]="5" [isInspectionAddEdit]="true"></upload-photo>
               
                 <i class="material-icons upload-container__icon"
                  style="border: 1px solid #ed5565;color: #ed5565; padding: 8px; cursor:pointer; margin-bottom: 5px;"
                   *ngIf="system?.SystemImages?.length >0" (click)="viewComponentHistoryPhoto(null, true,system)">
                  photo_library
                </i>
                 <i class="material-icons upload-container__icon"
                   style="border: 1px solid #ccc8c9;color: #ccc8c9; padding: 8px; cursor:pointer ;margin-bottom: 5px;"
                  *ngIf="system?.SystemImages?.length == 0" (click)="viewComponentHistoryPhoto(null, true,system)">
                  photo_library
                </i>
              </div>
                <div>
                <div *ngIf="(system?.SystemComment == null || system?.SystemComment?.length == 0) && isInspector" class="upload-container" (click)="viewComponentComment()" title="{{'Add Comment' | translate | async}}">
                  <i class="material-icons upload-container__icon">
                    message
                  </i>
                </div>

                <div *ngIf="system?.SystemComment != null && system?.SystemComment?.length > 0" class="upload-container" (click)="viewComponentComment()" title="{{'Edit/View Comment' | translate | async}}">
                  <i class="material-icons upload-container__icon" style ="border: 1px solid #ed5565;color: #ed5565; padding: 8px;" >
                    message
                  </i>
                </div>
              </div>
              </div>
    <div class="system-overview">
      <!-- <overview-image size="140" src="{{imageUrl}}" [loading]="loadingSystems"></overview-image> -->
      <overview-image size="140" *ngIf="!FamilyImage_Chain && systemType==1 " src="/Content/Images/chain.jpg" [loading]="loadingSystems"></overview-image>
      <overview-image size="140" *ngIf="FamilyImage_Chain && systemType==1 " [src]="getImage_(FamilyImage_Chain)" [loading]="loadingSystems"></overview-image>

      <overview-image size="140" *ngIf="!FamilyImage_Frame && systemType!==1" src="/Content/Images/frame.jpg" [loading]="loadingSystems"></overview-image>
      <overview-image size="140" *ngIf="FamilyImage_Frame && systemType!==1" [src]="getImage_(FamilyImage_Frame)" [loading]="loadingSystems"></overview-image>
      <div class="system-overview__content">
        <div class="content__primary">
          <item-group>
            <item [label]="'Serial Number' | translate | async" [primary]="true" [loading]="loadingSystems">{{system?.SystemSerialNumber}}</item>
            <item *ngIf="system?.Components.length == 0" [primary]="false" [loading]="loadingSystems">{{"There is no components on this system, please make sure your undercarriage setup correctly " | translate | async}}</item>
          </item-group>
        </div>
        <div *ngIf="systemType!=1" style="display: flex; flex-direction: row; justify-content: space-evenly; width: 500px;">
          <div class="column-container__column" *ngIf="showFrameConfigurtaion">
            <div class="text-block" style="display:flex; align-items: center;">
              <span class="text-block__label" style=" display: block; margin-bottom: 6px;font-size: 13px;color: #828282; font-weight: 400; margin-right: 20px; white-space: nowrap">
                {{ 'Frame Configuration'| translate | async }}
              </span>
              <span class="text-block__important" style="font-weight: unset;  display: flex; white-space: nowrap">
                <ng-container *ngIf="system?.ToeOutFrame == 0">
                  Unknown
                </ng-container>
                <ng-container *ngIf="system?.ToeOutFrame == 1">
                  {{ 'Toe Out'| translate | async }}
                </ng-container>
                <ng-container *ngIf="system?.ToeOutFrame == 2">
                  {{ 'Straight'| translate | async }}
                </ng-container>
                <ng-container>
                  <a (click)="openTrackCofiguration(1,system.ToeOutFrame,system?.SystemId)">
                    <i class="material-icons " style="color: black; font-size: 16px; cursor: pointer; margin-right: 20px;">create</i>
                  </a>
                </ng-container>
              </span>
              
            </div>
          </div>
          <div class="column-container__column" *ngIf="showCannonType">
            <div class="text-block" style="display:flex; align-items: center;">
              <span class="text-block__label" style=" display: block; margin-bottom: 6px;font-size: 13px;color: #828282; font-weight: 400; margin-right: 20px; white-space: nowrap">
                {{ 'Cannon Type'| translate | async }}
              </span>
              <span class="text-block__important" style="font-weight: unset; display: flex; white-space: nowrap">
                <ng-container *ngIf="system?.CastFrame == 0">
                  Unknown
                </ng-container>
                <ng-container *ngIf="system?.CastFrame == 1">
                  {{ 'Cast'| translate | async }}
                </ng-container>
                <ng-container *ngIf="system?.CastFrame == 2">
                  {{ 'Fabricated'| translate | async }}
                </ng-container>
                <ng-container>
                  <a (click)="openTrackCofiguration(2,system.CastFrame,system?.SystemId)">
                    <i class="material-icons " style="color: black; font-size: 16px; cursor: pointer; margin-right: 20px;">create</i>
                  </a>
                </ng-container>
              </span>
            </div>
          </div>
          <!-- bogie shim -->
           <div class="mtm-10" *ngIf="enableBogieShim && isBogieLoad">
             <app-bogie-shim [inspectionId]="inspectionDraftId" [side]="side" [isViewMode]="false" [bogieShimL]="bogieShimLeft" [bogieShimR]="bogieShimRight"></app-bogie-shim>
           </div>
        </div>
      </div>
    </div>
    <div class="table-container" *ngIf="system?.Components?.length > 0">
      <table class="table table--full-width table--striped">
        <thead>
          <tr>
            <th></th>
            <th>{{'Component' | translate | async}}</th>
            <th>{{'Position' | translate | async}}</th>
            <th>{{'Worn(%)' | translate | async}}</th>
            <th>{{'Measurement' | translate | async}}</th>
            <th>{{'Tool' | translate | async}}</th>
            <th *ngIf="UTEquivalenetEnabled">{{'UT Equivalent' | translate | async}}</th>
            <th>{{'CMU' | translate | async}} </th>
            <th *ngIf="isRSH">{{'PMU' | translate | async}} </th>
            <th *ngIf="EnableDistTravelledTracking">{{'DOC' | translate | async}} </th>
            <th class="right-align">{{'Photo' | translate | async}}</th>
            <th class="right-align"><div class="textCenter">{{'Comment' | translate | async}} </div></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of system?.Components">
            <td class="component-cell" *ngIf="!c.IsChild">
              <div class="component-photo-container">
                <img class="component-photo" [src]="sanitize(c.ComponentImage)" />
              </div>
            </td>
            <td *ngIf="c.IsChild" class="line-cell">
              <div class="line-vert{{getChildRowPosition(c.GeneralEqUnitId)}}"></div>
              <div class="line-hor"></div>
            </td>
            <td class="namecell">
              <span *ngIf="!c.IsChild" [title]="c.ComponentPitch  ? c.Name + ' - Pitch: ' + c.ComponentPitch + ' ' + userUOM : c.Name">
                {{ (c.ComponentPitch ? c.Name + ' - Pitch: ' + c.ComponentPitch + ' ' + userUOM : c.Name) | slice:0:35 }}
                {{ (c.Name.length > 35) ? '...' : '' }}
              </span>

              <span *ngIf="c.IsChild" [title]="c.ComponentPitch ? c.Name + ' - Pitch: ' + c.ComponentPitch + ' ' + userUOM : c.Name">
                {{(c.ComponentPitch ? c.Name + ' - Pitch: ' + c.ComponentPitch + ' ' + userUOM : c.Name) | slice:0:35 }}
                {{ (c.Name.length > 35) ? '...' : '' }}
              </span>
              <!-- <span title="{{c.Name}}" *ngIf="!c.IsChild && c.ComponentPitch == null">{{c.Name | slice:0:35}} {{c.Name.length>35 ? '...' : ''}} </span>
              <span title="{{c.Name + (c.ComponentPitch ? ' - Pitch:  ' + c.ComponentPitch + ' ' + userUOM : '')}}" 
              *ngIf="!c.IsChild && c.ComponentPitch != null">
              {{c.Name + (c.ComponentPitch > 0 ? ' - Pitch:  ' + c.ComponentPitch + ' ' + userUOM : '') | slice:0:30}} {{c.Name.length>35 ? '...' : ''}} </span>
              <span title="{{c.Name}}" *ngIf="c.IsChild && c.ComponentPitch == null">{{c.Name | slice:0:35}} {{c.Name.length>35 ? '...' : ''}}</span>
              <span title="{{c.Name + (c.ComponentPitch ? ' - Pitch:  ' + c.ComponentPitch + ' ' + userUOM : '')}}" 
               *ngIf="c.IsChild && c.ComponentPitch != null">
                {{c.Name + (c.ComponentPitch > 0 ? ' - Pitch:  ' + c.ComponentPitch + ' ' + userUOM : '') | slice:0:30}} {{c.Name.length>35 ? '...' : ''}}</span> -->
            </td>
            <td *ngIf="c.IsChild"></td>
            <td *ngIf="!c.IsChild"> {{showPosition(c.ActualPosition, c.CompartTypeId)}}</td>
            <td class="table__eval-cell">
              <span *ngIf="!isParent(c.GeneralEqUnitId)" style="width: 80px;" [ngClass]="GetEvalColour(c, c.WornPercentage.toFixed(1))">
                <div style="text-align: center !important; display: inline-block;">
                  <!-- Eval tool -->
                  <ng-container *ngIf="c.ToolId === ToolType.Eval">{{ c.EvalCode }}</ng-container>
                  <!-- Yes/No or Pass/Fail -->
                  <ng-container *ngIf="c.ToolId === ToolType.YESorNO || c.ToolId === ToolType.PassorFail">
                    {{'-'}}
                  </ng-container>
                  <!-- All others -->
                  <ng-container *ngIf="c.ToolId !== ToolType.Eval && c.ToolId !== ToolType.YESorNO && c.ToolId !== ToolType.PassorFail  && c.ToolId != ToolType.ConditionAssessment">
                    {{ c.MeasurementReading === -1 ? '-' : (c.WornPercentage.toFixed(1) + '%') }}
                  </ng-container>

                  <ng-container *ngIf="c.ToolId === ToolType.ConditionAssessment">
                    {{ c.EvalCode === 'A' ? 'Good' : c.EvalCode === 'B' ? 'Monitor' :    c.EvalCode === 'X' ? 'Failed' :'Good' }}
                    <!-- Monitor -->
                  </ng-container>
                </div>
              </span>
            </td>
            <td>
              <div *ngIf="!isParent(c.GeneralEqUnitId)">
                <div *ngIf=' (c.IsChild || !isParent(c.GeneralEqUnitId)) && c.ToolId !== ToolType.Eval && c.ToolId !== ToolType.YESorNO && c.ToolId !== ToolType.PassorFail && c.ToolId !== ToolType.ConditionAssessment'>
                  <input style="width: 100px;" type="number" [(ngModel)]="c.MeasurementReading == -1 ?null : c.MeasurementReading" (change)="updateComponentMeasurement(c.MeasurementReading, c.InspectionDraftDetailId, $event,c)">
                  <span [matMenuTriggerFor]="selectMeasurementUnit" class="tool-button" title="{{'Change Measurement Unit' | translate | async}}">{{c.IsMeasuredInInches ? 'Inches' : 'MM'}}</span>
                  <mat-menu #selectMeasurementUnit="matMenu">
                    <button mat-menu-item (click)="changeMeasurementUnit(c,false)">{{'MM' | translate | async}}</button>
                    <button mat-menu-item (click)="changeMeasurementUnit(c,true)">{{'Inches' | translate | async}}</button>
                  </mat-menu>
                </div>
              <div *ngIf="c.ToolId === ToolType.ConditionAssessment">
                <span [matMenuTriggerFor]="testMenu" class="tool-button"
                  title="{{'Change Tool' | translate | async}}">{{ c.EvalCode === 'A' ? 'Good' : c.EvalCode === 'B' ? 'Monitor' :    c.EvalCode === 'X' ? 'Failed' :'Good' }}</span>
                <mat-menu #testMenu="matMenu">
                  <button mat-menu-item (click)="changeEval( c,'Good', ToolType.ConditionAssessment)">
                    {{
                    'Good' |
                    translate | async
                    }}
                  </button>
                  <button mat-menu-item (click)="changeEval( c,'Monitor', ToolType.ConditionAssessment)">
                    {{
                    'Monitor' |
                    translate | async
                    }}
                  </button>
                  <button mat-menu-item
                    (click)="changeEval(c,'Failed', ToolType.ConditionAssessment)">
                    {{
                    'Failed' | translate |
                    async
                    }}
                  </button>
                  
                </mat-menu>
              </div>

                <div *ngIf='c.ToolId === ToolType.Eval'>
                  <span [matMenuTriggerFor]="SelectEvalForComponent" class="tool-button" title="{{'Change Component Eval' | translate | async}}">{{c.EvalCode }} </span>
                  <mat-menu #SelectEvalForComponent="matMenu">
                    <button mat-menu-item (click)="changeEval( c, 'A')">{{'A' | translate | async}}</button>
                    <button mat-menu-item (click)="changeEval( c, 'B')">{{'B' | translate | async}}</button>
                    <button *ngIf="c.isExcludeC==false" mat-menu-item (click)="changeEval( c, 'C')">{{'C' | translate | async}}</button>
                    <button mat-menu-item (click)="changeEval( c, 'X')">{{'X' | translate | async}}</button>
                  </mat-menu>
                </div>
                <div *ngIf='c.ToolId === ToolType.YESorNO'>
                  <span [matMenuTriggerFor]="yesNoMenu" class="tool-button" title="{{ 'Change Component Yes/No' | translate | async }}">
                    {{(c.MeasurementReading == -1 
                          ? 'U' 
                          : (c.MeasurementReading == 1 ? 'Yes' : 'No')
                      ) | translate | async}}
                  </span>
                  <mat-menu #yesNoMenu="matMenu">
                    <button mat-menu-item (click)="onToolOptionSelect(c, toolYesNo.Yes)">{{ 'Yes' | translate | async }}</button>
                    <button mat-menu-item (click)="onToolOptionSelect(c, toolYesNo.No)">{{ 'No' | translate | async }}</button>
                  </mat-menu>
                </div>
                <div *ngIf='c.ToolId === ToolType.PassorFail'>
                  <span [matMenuTriggerFor]="passFailMenu" class="tool-button" title="{{ 'Change Component Pass/Fail' | translate | async }}">
                    {{(c.MeasurementReading === -1 
                        ? 'U' 
                        : (c.MeasurementReading === 1 ? 'Pass' : 'Fail')
                    ) | translate | async }}
                  </span>
                  <mat-menu #passFailMenu="matMenu">
                    <button mat-menu-item (click)="onToolOptionSelect(c, toolPassFail.Pass)">{{ 'Pass' | translate | async }}</button>
                    <button mat-menu-item (click)="onToolOptionSelect(c, toolPassFail.Fail)">{{ 'Fail' | translate | async }}</button>
                  </mat-menu>
                </div>
              </div>
            </td>
            <td>
              <!-- <div *ngIf="(c.IsChild || !isParent(c.GeneralEqUnitId)) && isInspector && !isRopeShovel">

                  <span [matMenuTriggerFor]="selectToolMenu" class="tool-button" title="{{'Change tool' | translate | async}}">{{c.ToolName}}</span>
                  <mat-menu #selectToolMenu="matMenu">
                      <button mat-menu-item *ngFor="let tool of c.PossibleTools" (click)="changeTool(tool, c)">{{tool.ToolName}}</button>
                  </mat-menu>
              </div> -->

              <div *ngIf="(c.IsChild  || !isParent(c.GeneralEqUnitId)) && isInspector && isRopeShovel ">
                <span [matMenuTriggerFor]="selectToolMenu" class="tool-button" title="{{'Change tool' | translate | async}}">{{c.ToolName}}</span>

                <mat-menu #selectToolMenu="matMenu">
                  <button mat-menu-item *ngFor="let tool of c.PossibleTools" (click)="changeTool(tool, c)">{{tool.ToolName}}</button>

                  <!-- <button mat-menu-item (click)="updateComponentTool(c.Measurement, c.InspectionDetailId, 1)">{{'Ruler' | translate | async}}</button>
                  <button mat-menu-item (click)="updateComponentTool(c.Measurement, c.InspectionDetailId, 2)">{{'Depth Gauge' | translate | async}}</button>
                  <button mat-menu-item (click)="updateComponentTool(c.Measurement, c.InspectionDetailId, 3)">{{'Ultrasonic' | translate | async}}</button>
                  <button mat-menu-item (click)="updateComponentTool(c.Measurement, c.InspectionDetailId, 4)">{{'Calipers' | translate | async}}</button> -->
                </mat-menu>
              </div>

              <div *ngIf="(c.IsChild  || !isParent(c.GeneralEqUnitId)) && isInspector && !isRopeShovel">
                <span [matMenuTriggerFor]="selectToolMenu1" class="tool-button" title="{{'Change tool' | translate | async}}">{{c.ToolName}}</span>

                <mat-menu #selectToolMenu1="matMenu">
                  <button mat-menu-item *ngFor="let tool of c.PossibleTools" (click)="changeTool(tool, c)">{{tool.ToolName}}</button>

                  <!-- <button mat-menu-item (click)="updateComponentTool(c.Measurement, c.InspectionDetailId, 1)">{{'Ruler' | translate | async}}</button>
                  <button mat-menu-item (click)="updateComponentTool(c.Measurement, c.InspectionDetailId, 2)">{{'Depth Gauge' | translate | async}}</button>
                  <button mat-menu-item (click)="updateComponentTool(c.Measurement, c.InspectionDetailId, 3)">{{'Ultrasonic' | translate | async}}</button>
                  <button mat-menu-item (click)="updateComponentTool(c.Measurement, c.InspectionDetailId, 4)">{{'Calipers' | translate | async}}</button> -->
                </mat-menu>
              </div>



              <!-- <span *ngIf="(c.IsChild || !isParent(c.ComponentId)) && !isInspector">{{c.Tool}}</span> -->
            </td>
            <!-- <td class="right-align"><span *ngIf="!c.IsChild">{{c.Cmu}} hrs</span></td> -->
            <!-- <td class="right-align"><span *ngIf="!c.IsChild">{{c.RisidualLife100}} hrs</span></td>
            <td class="right-align"><span *ngIf="!c.IsChild">{{c.RisidualLife120}} hrs</span></td> -->


            <td *ngIf="UTEquivalenetEnabled">
              <span *ngIf="(c.IsChild || !isParent(c.GeneralEqUnitId)) && isInspector && c.ToolName!='UT' && c.hasUTTool">{{c.UTequvelent}} {{c.IsMeasuredInInches ? 'Inches' : 'MM'}}</span>
            </td>
            <td class="inspection-component-photo">
              {{ c.CMU }}
            </td>
            <td class="inspection-component-photo" *ngIf="isRSH">
              {{ c.CPMU }}
            </td>
            <td class="inspection-component-photo" *ngIf="EnableDistTravelledTracking">
              {{ c.DOC }}
            </td>
            <td class="right-align">
              <!-- multiple images will be implemented in the future-->
              <!-- <img  *ngFor="let image of c.Images" (click)="viewComponentPhoto(image, c)" class="inspection-component-photo__photo" [src]="getImage(image.Image)" />
              <upload-photo  (onPhotoUpload)="reloadSystem()" [inspectionId]="inspectionId" [inspectionDetailId]="c.InspectionDraftDetailId"
                [isCreatingNewInspection] ="creatingNewInspection"
              ></upload-photo> -->
              <upload-photo *ngIf="!c.TempOneImageOnly || c.TempOneImageOnly?.ImagePath == ''" [isCreatingNewInspection]="true" (onPhotoUpload)="loadPhoto(c, $event)" [inspectionId]="inspectionDraftId" [inspectionDetailId]="c.InspectionDraftDetailId" [imageUrl]="true"></upload-photo>
              <!-- <img (click)="viewComponentPhoto(c.TempOneImageOnly, c)" class="inspection-component-photo__photo" [src]="getImage(c.TempOneImageOnly.Image)" *ngIf="c.TempOneImageOnly.Image != ''" /> -->
              <i *ngIf="c.TempOneImageOnly && c.TempOneImageOnly.ImagePath != ''" class="material-icons upload-container__icon" style="border: 1px solid #ed5565;color: #ed5565; padding: 8px;" (click)="viewComponentPhoto(c.TempOneImageOnly, c)">
                add_a_photo
              </i>
            </td>
            <td class="right-align componentComment">
              <!-- {{c.Comment | slice:0:30}} {{c.Comment?.length>30 ? '...' : ''}}
              <div class="add-recommendation" [class.has-recommendation]="c.Comment !=='' && c.Comment!== null">
                <i title="Add Comment" class="material-icons" (click)="AddComment(c)">message</i>
              </div> -->


              <div class="add-recommendation" *ngIf="(c.Comment === ''  || c.Comment === null || c.Comment === undefined)" (click)="AddComment(c)" title="{{'Add Comment' | translate | async}}">
                <i class="material-icons observation-image__icon">
                  message
                </i>
              </div>
              <div *ngIf="c.Comment !== ''  && c.Comment !== null && c.Comment !== undefined" (click)="AddComment(c)">
                <i class="material-icons observation-image__icon" style="border: 1px solid #ed5565;color: #ed5565; padding: 8px;" matTooltip="{{c.Comment}}">
                  message
                </i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </panel>
</div>
